import { render, staticRenderFns } from "./N8nPagesHistoryTable.vue?vue&type=template&id=e4c95646&"
import script from "./N8nPagesHistoryTable.vue?vue&type=script&lang=js&"
export * from "./N8nPagesHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports